<div *ngIf="chatGPTFormGroup" [formGroup]="chatGPTFormGroup"
  class="d-flex align-items-center justify-content-between gap-2">
  <app-input [inputFormGroup]="chatGPTFormGroup" [inputFormControlName]="chatGPTFormControlName"
    [formControlName]="chatGPTFormControlName" [inputId]="chatGPTId" [inputName]="chatGPTName" inputType="base"
    (inputValueChange)="onFormChange($event.target, chatGPTFormControlName)" class="chat-gpt" type="text"
    [ngClass]="{ required: chatGPTRequired }" [inputAutocomplete]="chatGPTAutocomplete"
    [inputPlaceholder]="chatGPTPlaceholder ? chatGPTPlaceholder : ('DESCREVA_NECESSIDADE' | translate)"
    (focusChange)="focus($event)">
  </app-input>

  <app-button *ngIf="!aiChat" buttonId="chatGPTButton" container="body" [ngbTooltip]="translate.instant('PESQUISAR')"
    buttonType="icon" buttonAction="custom" buttonClass="btn btn-success btn-md-rounded-milvus-chatgpt"
    (buttonClicked)="onButtonClick()">
    <img [src]="currentImage" class="img-full" />
  </app-button>

  <img *ngIf="aiChat && !onChatViewer" container="body" [ngbTooltip]="translate.instant('PESQUISAR')"
    (click)="onButtonClick()" [src]="currentImage" class="open-ai-chat" />
  <button *ngIf="onChatViewer && (inputFocus || verificaInput())" type="button" container=".modal"
    [ngbTooltip]="translate.instant('ENVIAR_PARA_IA')" position="left" class="btn btn-chat-enviar"
    (click)="onButtonClick()">
    <i class="mdi mdi-send"></i>
  </button>

</div>